import { actionType } from "./actionType";

export const updateLoading = (value) => ({
  type: actionType.UPDATE_LOADER_STATE,
  payload: value,
});
